import { useAnalytics } from 'libs/utils/site/analytics';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtonsWithProgramme } from 'pages/custom/shared/detail/CompanyButtonsWithProgramme';
import { OverflowFilters } from 'pages/custom/shared/overflow/OverflowFilters';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect } from 'react';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const Kontakt2023Page = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);
    const analytics = useAnalytics();

    useEffect(() => {
        ctxView.setCustomPageConfig({
            hideLogoInList: true,
            storyIdsExcludedInList: ['2658f6f5-fc39-4fc3-99f7-6608118d4384']
        });

        Localization.setLanguage('cs');
    }, []);

    function isSetHighlighted(mapSetId: string) {
        return ctxView.visibleMapSetIds.includes(mapSetId);
    }

    const suteren = '7513d175-7fde-42f9-8784-50c85a45fa80';
    const prizemi = 'cc87d7b5-e2ce-4d5e-b1d1-7501a3f75c2d';
    const patro = 'f800e9ab-72fa-470a-a30f-156b657d5f46';

    function setVisibleMapSetAndHideOthers(mapSetId: string) {
        const visible = ctxView.visibleMapSetIds;
        const newVisible = visible.filter((id) => id !== suteren && id !== prizemi && id !== patro);
        newVisible.push(mapSetId);
        ctxView.setVisibleMapSetIds(newVisible);

        analytics.track('floor_button.clicked', {
            building: 'aula',
            source: 'custom_buttons',
            floorId: mapSetId
        });
    }

    return (
        <S_UIAPage className={props.className}>
            <CustomMapPage
                mapId={'a1b7c9ac-6973-473b-ad69-3f844ae4ef41'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/d99dd420-73e2-4896-b4b8-cc0e639c550c.png',
                    link: 'https://www.upce.cz/kontakt-2020-0',
                    linkText: Localization.WEBSITE
                }}
                controls={
                    <CompanyButtonsWithProgramme programeId="2658f6f5-fc39-4fc3-99f7-6608118d4384" />
                }
                hideFloors
                mapProps={{
                    light: {
                        anchor: 'viewport',
                        color: '#ccc',
                        intensity: 0.1
                    }
                }}
                topOverflow={
                    <OverflowFilters
                        highlightedBackground="linear-gradient(88.56deg,#bc4e4e 0%,#a31616 100%)"
                        items={[
                            {
                                iconName: 'layer-group',
                                text: 'Aula Suterén',
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(suteren);
                                },
                                highlighted: isSetHighlighted(suteren)
                            },
                            {
                                iconName: 'layer-group',
                                text: 'Aula Přízemí',
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(prizemi);
                                },
                                highlighted: isSetHighlighted(prizemi)
                            },
                            {
                                iconName: 'layer-group',
                                text: 'Aula 1. patro',
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(patro);
                                },
                                highlighted: isSetHighlighted(patro)
                            }
                        ]}
                    />
                }
            />
        </S_UIAPage>
    );
};

const S_UIAPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
